module.exports = __webpack_public_path__ + "img/TDE_Sword.2bec31fa.png";